import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import portfolioData from '../../data/portfolio.json';
import './details.scss';

const PortfolioDetails = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [project, setProject] = useState(null);

    useEffect(() => {
        const foundProject = portfolioData.portfolio.find(p => p.slug === slug);
        if (foundProject) {
            setProject(foundProject);
        } else {
            // Handle not found - maybe redirect back to portfolio
            navigate('/portfolio');
        }
    }, [slug, navigate]);

    if (!project) return null;

    return (
        <div className="container portfolio-details-page">
            <button className="back-btn" onClick={() => navigate('/portfolio')}>
                &larr; Back to Portfolio
            </button>

            <div className="details-header">
                <h1 className="project-title">{project.title}</h1>
                <p className="project-description">{project.description}</p>

                <div className="tech-stack">
                    {project.techStack?.map((tech, idx) => (
                        <span key={idx} className="tech-badge">{tech}</span>
                    ))}
                </div>
            </div>

            <div className="gallery-grid">
                {project.gallery?.map((img, idx) => (
                    <div key={idx} className="gallery-item">
                        <img src={img} alt={`${project.title} screenshot ${idx + 1}`} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PortfolioDetails;
